/* ============================================================
   FILTER SUPPLY — theme.js
   Product page: quantity steppers + variant option chips.
   Cart page uses native Shopify change links (no JS needed).
   ============================================================ */
(function () {
  "use strict";
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- quantity steppers ---- */
  function bindSteppers() {
    $all("[data-stepper]").forEach(function (wrap) {
      if (wrap.__b) return; wrap.__b = true;
      var input = wrap.querySelector("input");
      $all("[data-step]", wrap).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var d = parseInt(btn.getAttribute("data-step"), 10);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---- variant option chips ---- */
  function bindVariants() {
    var form = $("[data-product-form]");
    var tag = $("#fs-variants-json");
    if (!form || !tag) return;
    var variants = JSON.parse(tag.textContent);
    var idInput = form.querySelector("input[name=id]");
    var priceEl = $("[data-price]");
    var addBtn = form.querySelector("[data-add-to-cart]");
    var buyBtn = form.querySelector("[name=checkout]");
    var planInput = form.querySelector("[data-selling-plan-input]");
    var selectedPlan = "";

    function active(group) { var a = group.querySelector(".sf-chip.is-active"); return a ? a.getAttribute("data-value") : null; }
    function paint(chip, on) {
      chip.classList.toggle("is-active", on);
      chip.setAttribute("aria-pressed", on ? "true" : "false");
      chip.style.background = on ? "var(--ink)" : "transparent";
      chip.style.color = on ? "#fff" : "var(--ink)";
      chip.style.borderColor = on ? "var(--ink)" : "var(--line-2)";
    }
    function update() {
      // 表示順を並べ替えても正しく一致するよう、data-option-index（実際のオプション位置）で値を配置
      var opts = [];
      $all("[data-option-index]", form).forEach(function (g) { opts[+g.getAttribute("data-option-index")] = active(g); });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || variants[0];
      if (!match) return;
      idInput.value = match.id;
      // 価格：定期購入が選択されていればその価格、なければ通常価格（サーバ整形済み）
      var showPrice = (selectedPlan && match.plans && match.plans[selectedPlan]) ? match.plans[selectedPlan] : match.price;
      if (priceEl && showPrice) priceEl.textContent = showPrice;
      var mirror = $("[data-price-mirror]"); if (mirror && showPrice) mirror.textContent = showPrice;
      var sAdd = $("[data-sticky-add]"); if (sAdd) sAdd.disabled = !match.available;
      // 在庫状態をボタンへ反映
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (addBtn.getAttribute("data-label-add") || addBtn.textContent)
          : (addBtn.getAttribute("data-label-sold") || addBtn.textContent);
      }
      if (buyBtn) buyBtn.style.display = match.available ? "" : "none";
      // URL に ?variant= を反映（リロード・共有で選択を保持）
      if (match.url && window.history && history.replaceState) {
        history.replaceState({}, "", match.url);
      }
    }
    $all("[data-option-index]", form).forEach(function (group) {
      $all(".sf-chip", group).forEach(function (chip) {
        chip.addEventListener("click", function () {
          $all(".sf-chip", group).forEach(function (c) { paint(c, false); });
          paint(chip, true); update();
        });
      });
    });
    // 購入タイプ（1回のみ / 定期購入）
    $all("input[name=purchase_type]", form).forEach(function (radio) {
      radio.addEventListener("change", function () {
        selectedPlan = radio.getAttribute("data-selling-plan") || "";
        if (planInput) planInput.value = selectedPlan;
        $all(".ptype-opt", form).forEach(function (o) { o.classList.remove("is-active"); });
        var lbl = radio.closest(".ptype-opt"); if (lbl) lbl.classList.add("is-active");
        update();
      });
    });
    // 初期選択（定期便のみ商品では非表示ラジオが checked）を反映
    var checkedType = form.querySelector("input[name=purchase_type]:checked");
    if (checkedType) {
      selectedPlan = checkedType.getAttribute("data-selling-plan") || "";
      if (planInput) planInput.value = selectedPlan;
    }
    update();
  }

  /* ---- scroll fade ---- */
  function armFades() {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -6% 0px" });
    document.querySelectorAll(".fade").forEach(function (el) { io.observe(el); });
  }

  function initMobileNav() {
    var burger = document.querySelector(".hdr__burger");
    var nav    = document.querySelector(".hdr__nav");
    if (!burger || !nav) return;
    var overlay = document.getElementById("nav-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "nav-overlay";
      overlay.className = "nav-overlay";
      document.body.appendChild(overlay);
    }
    function toggleMenu(open) {
      nav.classList.toggle("is-open", open);
      overlay.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
      burger.setAttribute("aria-expanded", String(open));
    }
    burger.addEventListener("click", function () {
      toggleMenu(!nav.classList.contains("is-open"));
    });
    overlay.addEventListener("click", function () { toggleMenu(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") toggleMenu(false);
    });
  }

  function initScrollUI() {
    var hdr = document.querySelector(".hdr");
    if (hdr) {
      window.addEventListener("scroll", function () {
        hdr.classList.toggle("is-scrolled", window.scrollY > 10);
      }, { passive: true });
    }
    if (!document.getElementById("scroll-progress")) {
      var bar = document.createElement("div");
      bar.id = "scroll-progress";
      document.body.prepend(bar);
      window.addEventListener("scroll", function () {
        var h = document.body.scrollHeight - window.innerHeight;
        bar.style.width = (h > 0 ? window.scrollY / h * 100 : 0) + "%";
      }, { passive: true });
    }
  }

  /* ---- smart header (white over dark hero) ---- */
  function initSmartHeader() {
    var hdr = document.querySelector(".hdr");
    var hero = document.querySelector(".hero");
    if (!hdr || !hero) return;
    var sentinel = document.createElement("div");
    sentinel.style.cssText = "position:absolute;bottom:0;left:0;width:1px;height:1px;pointer-events:none;";
    hero.style.position = "relative";
    hero.appendChild(sentinel);
    new IntersectionObserver(function (entries) {
      hdr.classList.toggle("hdr--light", entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ---- product image lightbox (zoom) ---- */
  function initZoom() {
    var imgs = $all("[data-zoom]");
    if (!imgs.length) return;
    var box = null;
    function open(src, alt) {
      if (!box) {
        box = document.createElement("div");
        box.className = "lightbox";
        box.innerHTML = '<button class="lightbox__close" type="button" aria-label="閉じる">&times;</button><img alt="">';
        document.body.appendChild(box);
        box.addEventListener("click", function (e) {
          if (e.target === box || e.target.classList.contains("lightbox__close")) close();
        });
        document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
      }
      box.querySelector("img").src = src;
      box.querySelector("img").alt = alt || "";
      document.body.style.overflow = "hidden";
      requestAnimationFrame(function () { box.classList.add("is-open"); });
    }
    function close() { if (box) { box.classList.remove("is-open"); document.body.style.overflow = ""; } }
    imgs.forEach(function (img) {
      img.style.cursor = "zoom-in";
      img.addEventListener("click", function () { open(img.getAttribute("data-zoom"), img.alt); });
    });
  }

  /* ---- product thumbnails -> swap main image on hover ---- */
  function initThumbs() {
    var main = $("[data-main-image]");
    var thumbs = $all("[data-thumb]");
    if (!main || thumbs.length < 2) return;
    function swap(t) {
      var src = t.getAttribute("data-src");
      if (!src || main.src === src) {
        thumbs.forEach(function (o) { o.classList.toggle("is-active", o === t); });
        return;
      }
      main.src = src;
      var ss = t.getAttribute("data-srcset");
      if (ss) main.srcset = ss;
      var zoom = t.getAttribute("data-zoom");
      if (zoom) main.setAttribute("data-zoom", zoom);
      main.alt = t.getAttribute("data-alt") || main.alt;
      thumbs.forEach(function (o) { o.classList.toggle("is-active", o === t); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener("mouseenter", function () { swap(t); });
      t.addEventListener("focus", function () { swap(t); });
      t.addEventListener("click", function (e) { e.preventDefault(); swap(t); });
    });
  }

  /* ---- sticky add-to-cart (mobile) ---- */
  function initStickyBuy() {
    var bar = $("[data-sticky-buy]");
    var form = $("[data-product-form]");
    if (!bar || !form) return;
    var realAdd = form.querySelector("[data-add-to-cart]");
    var anchor = form.querySelector(".fprod__buy") || realAdd;
    if (!anchor) return;
    bar.querySelector("[data-sticky-add]").addEventListener("click", function () {
      if (realAdd) realAdd.click();
    });
    if (!("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      // 本来の購入ボタンが画面外のときだけ固定バーを出す
      bar.classList.toggle("is-shown", !entries[0].isIntersecting);
    }, { rootMargin: "0px 0px -10% 0px" }).observe(anchor);
  }

  /* ---- back to top ---- */
  function initBackToTop() {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "to-top";
    btn.setAttribute("aria-label", "ページ上部へ戻る");
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,14 12,8 18,14"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    window.addEventListener("scroll", function () {
      btn.classList.toggle("is-shown", window.scrollY > 600);
    }, { passive: true });
  }

  /* ---- cart count morph ---- */
  function initCartMorph() {
    document.addEventListener("click", function (e) {
      if (!e.target.closest("[type=submit]")) return;
      setTimeout(function () {
        $all("[data-cart-count]").forEach(function (el) {
          el.classList.remove("cart-pop");
          void el.offsetWidth;
          el.classList.add("cart-pop");
        });
      }, 300);
    });
  }

  /* ---- bird cursor（鳥が飛んでるみたいに追従。PC・モーション許可時のみ） ---- */
  function initBirdCursor() {
    if (!window.matchMedia) return;
    if (!matchMedia("(pointer:fine)").matches) return;            // タッチ端末では無効
    if (matchMedia("(prefers-reduced-motion:reduce)").matches) return;
    if (document.querySelector(".bird-cursor")) return;

    // 羽ばたきの各ポーズ（翼の位置だけ違う「継ぎ目のない単一シルエット」）。
    // 胴体・頭・尾は共通で、翼だけが上→下に動く。順に切り替えて羽ばたかせる。
    var POSES = [
      "M1140 5715 c-15 -19 -8 -50 47 -198 25 -67 60 -165 78 -217 18 -52 47 -129 65 -170 17 -41 60 -147 95 -235 65 -164 237 -521 394 -817 435 -821 1093 -1708 1778 -2395 106 -107 193 -199 193 -203 0 -5 -7 -25 -16 -44 -29 -60 0 -81 201 -151 113 -39 114 -45 24 -134 -211 -209 -452 -315 -854 -376 -55 -8 -75 -21 -55 -35 65 -42 298 -93 491 -107 160 -11 155 -22 -64 -138 -153 -82 -154 -89 -13 -93 397 -10 1230 296 1746 641 209 140 379 262 510 367 396 316 498 392 659 485 204 118 386 198 551 241 197 51 230 63 230 84 0 19 -7 20 -107 20 -465 -2 -658 -46 -1097 -252 -357 -167 -426 -198 -518 -237 -369 -152 -508 -154 -963 -12 -106 32 -102 30 -314 206 -134 110 -184 157 -464 423 -152 146 -316 308 -364 361 -48 53 -133 143 -188 201 -97 100 -291 322 -495 564 -244 291 -598 750 -780 1012 -155 225 -426 652 -544 859 -38 66 -86 149 -106 185 -21 36 -48 88 -60 117 -24 56 -42 70 -60 48z",
      "M340 4957 c0 -13 39 -86 86 -163 48 -76 112 -179 142 -229 30 -49 94 -146 141 -215 48 -69 109 -159 135 -200 27 -41 76 -109 110 -150 34 -41 73 -91 86 -110 33 -48 180 -230 206 -255 11 -11 72 -83 134 -160 285 -351 795 -857 1205 -1194 88 -73 192 -158 230 -190 39 -32 95 -76 125 -97 30 -21 146 -106 256 -189 111 -82 280 -201 375 -263 133 -86 178 -120 189 -145 18 -39 138 -94 294 -135 117 -31 118 -32 68 -119 -146 -249 -368 -424 -707 -558 -165 -65 -174 -79 -58 -91 84 -9 95 -18 59 -48 -45 -37 -27 -46 93 -46 415 0 1231 301 1741 643 209 140 379 262 510 367 396 316 498 392 659 485 204 118 386 198 551 241 197 51 230 63 230 84 0 19 -7 20 -107 20 -465 -2 -658 -46 -1097 -252 -357 -167 -426 -198 -518 -237 -373 -154 -534 -154 -998 -1 -239 78 -1114 588 -1450 845 -30 23 -80 57 -110 77 -114 72 -616 453 -756 574 -39 33 -106 88 -150 121 -43 33 -122 98 -175 144 -53 46 -145 126 -205 178 -356 306 -1049 1011 -1212 1234 -46 62 -82 77 -82 34z",
      "M0 3812 c0 -69 250 -337 543 -582 123 -103 330 -270 404 -327 38 -29 109 -85 159 -125 145 -115 296 -224 433 -311 69 -44 171 -110 226 -147 88 -58 268 -168 460 -278 89 -52 573 -304 625 -326 25 -11 151 -69 280 -129 129 -60 264 -120 300 -132 36 -13 117 -44 180 -70 183 -74 343 -124 462 -144 135 -24 133 -21 99 -101 -115 -267 -316 -466 -654 -646 -145 -77 -150 -88 -46 -92 87 -3 101 -13 71 -45 -35 -37 -28 -40 78 -33 196 12 621 156 682 230 21 26 51 41 145 75 180 65 623 293 803 414 209 140 379 262 510 367 396 316 498 392 659 485 204 118 386 198 551 241 197 51 230 63 230 84 0 19 -7 20 -107 20 -465 -2 -658 -46 -1097 -252 -357 -167 -426 -198 -518 -237 -316 -130 -641 -162 -678 -66 -6 17 -19 26 -42 29 -311 50 -393 71 -570 142 -98 39 -118 44 -163 39 -45 -5 -76 3 -310 83 -482 166 -574 200 -890 337 -55 24 -129 55 -165 70 -121 49 -524 239 -700 329 -96 49 -227 115 -290 146 -63 31 -182 95 -265 142 -82 46 -190 106 -240 133 -49 26 -142 80 -205 120 -63 39 -136 84 -162 99 -51 29 -566 371 -633 420 -22 17 -63 47 -91 68 -70 52 -74 50 -74 -30z",
      "M0 2673 c1 -98 1 -98 72 -143 236 -148 1085 -565 1335 -656 71 -25 184 -68 252 -96 175 -69 594 -207 801 -263 96 -26 211 -57 255 -70 44 -13 114 -30 155 -39 41 -8 174 -38 295 -66 121 -28 263 -58 315 -65 52 -8 165 -26 250 -40 85 -15 220 -30 300 -33 171 -8 170 -8 117 -113 -127 -249 -315 -427 -630 -595 -70 -37 -126 -72 -124 -78 12 -36 315 -10 530 45 131 33 129 23 -19 -137 -133 -143 -134 -152 -9 -115 230 70 605 305 619 388 9 54 4 51 201 150 225 113 437 231 535 296 209 140 379 262 510 367 396 316 498 392 659 485 204 118 386 198 551 241 197 51 230 63 230 84 0 19 -7 20 -107 20 -465 -2 -658 -46 -1097 -252 -357 -167 -426 -198 -518 -237 -251 -103 -377 -129 -544 -112 -168 17 -180 24 -176 99 2 45 -1 62 -10 63 -7 1 -103 0 -213 -1 -201 -2 -201 -2 -329 49 -154 61 -156 61 -187 14 -34 -53 -231 -47 -644 17 -33 5 -114 17 -180 25 -128 17 -298 46 -405 70 -36 8 -119 24 -185 35 -105 19 -326 68 -699 156 -60 14 -148 37 -195 51 -47 14 -167 47 -266 73 -388 102 -881 265 -1238 409 -225 90 -207 93 -207 -26z"
    ];
    var SEQ = [0, 1, 2, 3, 2, 1];   // ピンポン再生（下げ→上げ→…）で羽ばたき

    var el = document.createElement("div");
    el.className = "bird-cursor";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<svg viewBox="0 0 720 606" width="36" height="30">' +
      '<g transform="translate(0,606) scale(0.1,-0.1)" fill="currentColor">' +
      '<path d="' + POSES[0] + '"/></g></svg>';
    document.body.appendChild(el);
    var pathEl = el.querySelector("path");

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    var x = tx, y = ty, px = x, py = y;
    var dir = 1, rot = 0, ft = 0, cur = -1, shown = false;

    document.addEventListener("mousemove", function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { shown = true; el.classList.add("is-on"); }
    }, { passive: true });
    document.addEventListener("mouseleave", function () { el.classList.remove("is-on"); });
    document.addEventListener("mouseenter", function () { if (shown) el.classList.add("is-on"); });

    function frame() {
      // カーソルに少し遅れて追従（滑空感）
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      var vx = x - px, vy = y - py; px = x; py = y;
      var speed = Math.sqrt(vx * vx + vy * vy);
      // 進行方向（水平）へ向きを反転。小さな揺れで反転しないようヒステリシス
      if (vx > 0.6) dir = 1; else if (vx < -0.6) dir = -1;
      // 縦の動きで軽くバンク（傾き）
      var tilt = Math.max(-11, Math.min(11, vy * 1.6)) * dir;
      rot += (tilt - rot) * 0.15;
      // 体(viewBox上≈60%,74%)をカーソルに合わせて配置＋進行方向＋向き反転
      el.style.transform =
        "translate(" + (x - 21.6) + "px," + (y - 22.4) + "px) rotate(" + rot +
        "deg) scaleX(" + dir + ")";
      // 羽ばたき：翼の位置だけ違うポーズを順に切り替え。静止時もゆっくり、動くと速く。
      ft += 0.16 + Math.min(speed, 20) * 0.02;
      var idx = SEQ[Math.floor(ft) % SEQ.length];
      if (idx !== cur) { cur = idx; pathEl.setAttribute("d", POSES[idx]); }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  document.addEventListener("DOMContentLoaded", function () { bindSteppers(); bindVariants(); armFades(); initMobileNav(); initScrollUI(); initCartMorph(); initZoom(); initThumbs(); initStickyBuy(); initBackToTop(); initBirdCursor(); });
  document.addEventListener("shopify:section:load", function () { bindSteppers(); bindVariants(); armFades(); });
})();
